import {
  GET_BD_USER,
  GET_DEPARTMENT,
  GET_PROJECT_LIST,
  ADD_TASK,
  GET_TASK,
  GET_TASK_CATEGORY,
  GET_TASK_EXPORT,
  GET_FEASIBILITY_REPORT_DETAIL,
  UPDATE_TASK_OWNER,
  UPDATE_TASK_START,
  UPDATE_TASK_COMPLETED,
  GET_TASK_DETAIL,
  GET_TASK_PROJECT_FILTER,
  GET_TASK_CATEGORY_FILTER,
  GET_TASK_DEPARTMENT_FILTER,
  GET_TASK_OWNER_FILTER,
  GET_USER_DESIGNATION,
  GET_USER_ROLE_FUNCTIONALITY,
  CREATE_USER_ROLE_FUNCTIONALITY,
  GET_PUBLIC_HOLIDAY_LIST,
  GET_YEAR,
  GET_SALARY_ADVANCE_DEDUCTION_HISTORY,
  GET_SALARY_ADVANCE_EXPORT,
  GET_SALARY_ADVANCE,
  GET_OUT_PASS,
  GET_EMPLOYEE,
  GET_OUT_PASS_EXPORT,
  GET_EMPLOYEE_ATTENDANCE,
  GET_LEAVE_TYPE,
  GET_EMPLOYEE_CHECKIN,
  GET_PETTY_CASH,
  GET_PETTY_CASH_MASTER_EXPORT,
  GET_LEAVE_SUMMARY,
  GET_COMP_OFF_LEAVE_SUMMARY,
  GET_VEHICLE_SERVICE_REQUEST,
  GET_VECHICLE_TYPE,
  GET_SERVICE_TYPE,
  GET_EMPLOYEE_ATTENDANCE_EXPORT,
  GET_VEHICLE_SERVICE_REQUEST_EXPORT,
  GET_VEHICLE_NUMBER,
  GET_GST,
  GET_ASSEST_TYPE,
  GET_DESIGNATION,
  GET_DESIGNATION_EXPORT,
  GET_DEPARTMENT_MASTER,
  GET_DEPARTMENT_EXPORT,
  GET_LEVEL,
  GET_LEVEL_EXPORT,
  GET_JOB_ROLE,
  GET_DEPARTMENT_DESIGNATION,
  GET_TASK_ACCOUNTABLE_FILTER,
  GET_APPRAISAL_QUESTION_EXPORT,
  GET_APPRAISAL_QUESTION_OPTION,
  GET_APPRAISAL_QUESTION_OPTION_EXPORT,
  GET_EMPLOYEE_APPRAISAL_QUESTION,
  GET_EMPLOYEE_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_EXPORT,
  GET_APPRAISAL_QUESTION,
  GET_APPRAISAL,
  GET_APPRAISAL_CATEGORY,
  GET_APPRAISAL_RATING,
  GET_QUESTION,
  GET_QUESTION_VALUE,
  GET_QUESTION_VALUE_SET,
  GET_APPRAISAL_QUESTION_PRINT,
  GET_HR_LEAVE_TYPE,
  GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT,
  GET_TO_DO_CATEGORY,
  GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE,
  GET_HR_APPRAISAL_QUESTION_DESIGNATION,
  GET_APPRAISAL_RATING_EXPORT,
  GET_APPRAISAL_QUESTION_CATEGORY_FILTER,
  GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER,
  GET_APPRAISAL_QUESTION_DESIGNATION_FILTER,
  GET_HR_APPRAISAL_QUESTION_OPTION,
  GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL,
  GET_EMPLOYEE_FOR_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE,
  GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL,
  GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL,
  GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT,
  GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION,
  GET_EMPLOYEE_APPRAISAL_DETAIL,
  GET_PENDING_TODO,
  GET_USER_ROLE_FUNCTIONALITY_DETAIL,
  GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT,
  GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION,
  GET_USER_BATA,
  GET_USER_BATA_FILTER_USER,
  GET_USER_BATA_EXPORT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE,
  GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT,
  GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL,
  GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT,
  GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT,
  GET_HR_SALARY_ADVANCE_FILTER_USER,
  GET_HR_SALARY_ADVANCE_DETAIL,
  GET_SETTING_ITEM,
  GET_ADMIN_SETTING,
  GET_SETTING_ITEM_OPTION,
  GET_ADMIN_SETTING_VALUE,
  GET_ADMIN_SETTING_DETAILS,
  GET_CRM_SITE_STATUS_FOR_RELEASE_STATUS,
  GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE,
  GET_SALARY_SLIP_FILTER_EMPLOYEE,
  GET_SALARY_SLIP,
  GET_SALARY_SLIP_EXPORT,
  GET_SALARY_SLIP_FILTER_DEPARTMENT,
  GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL,
  GET_SALARY_SLIP_DETAIL,
  GET_PAYMENT_AUTHORITY,
  GET_PAYMENT_AUTHORITY_FILTER_PAYMENT_CATEGORY,
  GET_PAYMENT_CATEGORIES,
  GET_PAYMENT_AUTHORITY_FILTER_USER,
  GET_PAYMENT_AUTHORITY_EXPORT,
  GET_ADMIN_MEETING,
  GET_ADMIN_MEETING_DETAIL,
  GET_ADMIN_MEETING_CATEGORY,
  GET_ATTENDEE_FOR_ADMIN_MEETING,
  GET_ADMIN_MEETING_FILTER_DEPARTMENT,
  GET_ADMIN_MEETING_FILTER_HOSTED_BY,
  GET_ADMIN_MEETING_FILTER_CATEGORY,
  // Training Training
  GET_TRAINING_SCHEDULE,
  GET_TRAINING_SCHEDULE_DETAIL,
  GET_TRAINING_SCHEDULE_FILTER_DEPARTMENT,
  GET_TRAINING_SCHEDULE_FILTER_TRAINER,
  GET_ATTENDEE_FOR_TRAINING_SCHEDULE,
  GET_ATTENDEE_TRAINING_SCHEDULE,
  GET_TRAINING_SCHEDULE_EXPORT,
  // Admin Training
  GET_TRAINING,
  GET_TRAINING_DETAIL,
  GET_TRAINING_DOCUMENT,
  GET_TRAINING_ATTENDEE,
  GET_TRAINING_FEEDBACK,
  GET_TRAINING_AVAILABILITY,
  GET_TRAINING_ATTENDEE_EXPORT,
  //ticket
  GET_TICKET,
  GET_TICKET_EXPORT,
  GET_TICKET_FILTER_DEPARTMENT,
  GET_TICKET_FILTER_ASSIGNED_TO,
  GET_TICKET_DETAIL,
  GET_TICKET_STATUS,
  GET_TICKET_FILTER_STATUS,
  GET_TRAINING_FILTER_TRAINER,
  // Module Requriment
  GET_MODULE_REQUIREMENT,
  GET_MODULE_REQUIREMENT_DETAIL,
  GET_MODULE_REQUIREMENT_FILTER_DEPARTMENT,
  GET_MODULE_REQUIREMENT_EXPORT,
  GET_MODULE_REQUIREMENT_FILTER_DEVELOPER_STATUS,
  // User Project Map
  GET_PROJECT_USER_MAP,
  GET_PROJECT_USER_MAP_FILTER_USER,
  GET_PROJECT_USER_MAP_FILTER_PROJECT,
  GET_ITEM_FOR_PROJECT_USER_MAP,
  GET_PROJECT_USER_MAP_EXPORT
} from "./types";
const initialStateChart = {
  labels: [],
  datasets: []
};
const initialState = {
  projectAuthority: [],
  // civilResourceTypePlanning : initialStateChart,
  // civilBudgetPlanning : initialStateChart,
  user: [],
  projectList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  departmentList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  feasibilityReportDetail: [],
  createTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTask: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskOwner: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskStart: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  updateTaskComplete: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskCategoryFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskDepartmentFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskOwnerFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionality: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  createUserRoleFunctionality: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPublicHolidayList: {
    error: false,
    message: "",
    data: []
  },
  getYear: {
    error: false,
    message: "",
    data: []
  },
  getSalaryAdvanceMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryAdvanceMasterExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalaryAdvanceDeductionHistory: {
    error: false,
    message: "",
    data: []
  },
  getOutPass: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getOutPassExport: {
    error: false,
    message: "",
    data: []
  },
  getEmployeeAttendance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLeaveType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeCheckin: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashMaster: {
    error: false,
    message: "",
    data: []
  },
  getPettyCashMasterExport: {
    error: false,
    message: "",
    data: []
  },
  getLeaveSummary: {
    error: false,
    message: "",
    data: []
  },
  getCompOffLeaveSummary: {
    error: false,
    message: "",
    data: []
  },
  getVehicleServiceRequest: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getServiceType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAttendanceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleServiceRequestExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getVehicleNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getGst: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDesignationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLevelExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getJobRole: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLevel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getDepartmentDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTaskAccountableFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionOptionExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalRating: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getFeedbackQuestion: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getFeedbackQuestionOptionValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getFeedbackQuestionOptionValueSet: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrLeaveType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestionPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getToDoCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionDesignationForUpdate: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  getHrAppraisalQuestionDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalRatingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionCategoryFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionDepartmentFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAppraisalQuestionDesignationFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrAppraisalQuestionOptionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeForAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeDepartmentForAppraisal: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalFilterDesgination: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPendingToDo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityFilterDesignation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserRoleFunctionalityFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBata: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBataFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getUserBataExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //full and final
  getEmployeeFinalSettlement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeFinalSettlementPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getHrSalaryAdvanceFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSettingValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSettingItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSetting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSettingItemOption: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdmSettingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCrmSiteStatusForReleaseStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //SALARY SLIP
  getSalarySlip: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterEmployeeType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getEmployeeAppraisalQuestionDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSalarySlipDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentAuthority: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentAuthorityFilterPayment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentCategories: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentAuthorityFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getPaymentAuthorityExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  //Meeting
  getAdminMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdminMeetingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMeetingCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendeeForAdminMeeting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdminMeetingFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdminMeetingFilterHostedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAdminMeetingFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Training //
  getTrainingSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingScheduleDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingScheduleFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingScheduleFilterTrainer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendeeForTrainingSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAttendeeTrainingSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingScheduleExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingAttendeeExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingFilterTrainer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Admin Training //

  getTraining: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingDocument: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingAttendee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainingFeedback: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTrainerAvailability: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // ticket
  getTicket: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getTicketFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  //Module Requriment
  getModuleRequirement: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModuleRequirementDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModuleRequirementFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModuleRequirementExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModuleRequirementFilterDevelopementStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Usere Project Map
  getProjectUserMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectUserMapFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectUserMapFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getItemForProjectUserMap: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectUserMapExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};
const Admin_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BD_USER:
      return Object.assign({}, state, { user: payload });
    case GET_DEPARTMENT:
      return Object.assign({}, state, { departmentList: payload });
    case GET_PROJECT_LIST:
      return Object.assign({}, state, { projectList: payload });
    case ADD_TASK:
      return Object.assign({}, state, { createTask: payload });
    case GET_TASK:
      return Object.assign({}, state, { getTask: payload });
    case GET_TASK_CATEGORY:
      return Object.assign({}, state, { getTaskCategory: payload });
    case GET_TASK_EXPORT:
      return Object.assign({}, state, { getTaskExport: payload });
    case GET_FEASIBILITY_REPORT_DETAIL:
      return Object.assign({}, state, { feasibilityReportDetail: payload });
    case UPDATE_TASK_OWNER:
      return Object.assign({}, state, { updateTaskOwner: payload });
    case UPDATE_TASK_START:
      return Object.assign({}, state, { updateTaskStart: payload });
    case UPDATE_TASK_COMPLETED:
      return Object.assign({}, state, { updateTaskComplete: payload });
    case GET_TASK_DETAIL:
      return Object.assign({}, state, { getTaskDetail: payload });
    case GET_TASK_PROJECT_FILTER:
      return Object.assign({}, state, { getTaskProjectFilter: payload });
    case GET_TASK_CATEGORY_FILTER:
      return Object.assign({}, state, { getTaskCategoryFilter: payload });
    case GET_TASK_DEPARTMENT_FILTER:
      return Object.assign({}, state, { getTaskDepartmentFilter: payload });
    case GET_TASK_OWNER_FILTER:
      return Object.assign({}, state, { getTaskOwnerFilter: payload });
    case GET_USER_DESIGNATION:
      return Object.assign({}, state, { getUserDesignation: payload });
    case GET_USER_ROLE_FUNCTIONALITY:
      return Object.assign({}, state, { getUserRoleFunctionality: payload });
    case CREATE_USER_ROLE_FUNCTIONALITY:
      return Object.assign({}, state, { createUserRoleFunctionality: payload });
    case GET_PUBLIC_HOLIDAY_LIST:
      return Object.assign({}, state, { getPublicHolidayList: payload });
    case GET_YEAR:
      return Object.assign({}, state, { getYear: payload });
    case GET_SALARY_ADVANCE:
      return Object.assign({}, state, { getSalaryAdvanceMaster: payload });
    case GET_SALARY_ADVANCE_DEDUCTION_HISTORY:
      return Object.assign({}, state, {
        getSalaryAdvanceDeductionHistory: payload
      });
    case GET_SALARY_ADVANCE_EXPORT:
      return Object.assign({}, state, {
        getSalaryAdvanceMasterExport: payload
      });
    case GET_OUT_PASS:
      return Object.assign({}, state, { getOutPass: payload });
    case GET_EMPLOYEE:
      return Object.assign({}, state, { getEmployee: payload });
    case GET_OUT_PASS_EXPORT:
      return Object.assign({}, state, { getOutPassExport: payload });
    case GET_EMPLOYEE_ATTENDANCE:
      return Object.assign({}, state, { getEmployeeAttendance: payload });
    case GET_LEAVE_TYPE:
      return Object.assign({}, state, { getLeaveType: payload });
    case GET_EMPLOYEE_CHECKIN:
      return Object.assign({}, state, { getEmployeeCheckin: payload });
    case GET_PETTY_CASH:
      return Object.assign({}, state, { getPettyCashMaster: payload });
    case GET_PETTY_CASH_MASTER_EXPORT:
      return Object.assign({}, state, { getPettyCashMasterExport: payload });
    case GET_LEAVE_SUMMARY:
      return Object.assign({}, state, { getLeaveSummary: payload });
    case GET_COMP_OFF_LEAVE_SUMMARY:
      return Object.assign({}, state, { getCompOffLeaveSummary: payload });
    case GET_VEHICLE_SERVICE_REQUEST:
      return Object.assign({}, state, { getVehicleServiceRequest: payload });
    case GET_VECHICLE_TYPE:
      return Object.assign({}, state, { getVehicleType: payload });
    case GET_SERVICE_TYPE:
      return Object.assign({}, state, { getServiceType: payload });
    case GET_EMPLOYEE_ATTENDANCE_EXPORT:
      return Object.assign({}, state, { getEmployeeAttendanceExport: payload });
    case GET_VEHICLE_SERVICE_REQUEST_EXPORT:
      return Object.assign({}, state, {
        getVehicleServiceRequestExport: payload
      });
    case GET_VEHICLE_NUMBER:
      return Object.assign({}, state, { getVehicleNumber: payload });
    case GET_GST:
      return Object.assign({}, state, { getGst: payload });
    case GET_ASSEST_TYPE:
      return Object.assign({}, state, { getAssetType: payload });
    case GET_DESIGNATION:
      return Object.assign({}, state, { getDesignation: payload });
    case GET_DESIGNATION_EXPORT:
      return Object.assign({}, state, { getDesignationExport: payload });
    case GET_DEPARTMENT_MASTER:
      return Object.assign({}, state, { getDepartmentMaster: payload });
    case GET_DEPARTMENT_EXPORT:
      return Object.assign({}, state, { getDepartmentExport: payload });
    case GET_LEVEL:
      return Object.assign({}, state, { getLevel: payload });
    case GET_LEVEL_EXPORT:
      return Object.assign({}, state, { getLevelExport: payload });
    case GET_JOB_ROLE:
      return Object.assign({}, state, { getJobRole: payload });
    case GET_DEPARTMENT_DESIGNATION:
      return Object.assign({}, state, { getDepartmentDesignation: payload });
    case GET_TASK_ACCOUNTABLE_FILTER:
      return Object.assign({}, state, { getTaskAccountableFilter: payload });
    case GET_APPRAISAL_QUESTION:
      return Object.assign({}, state, { getAppraisalQuestion: payload });
    case GET_APPRAISAL_QUESTION_EXPORT:
      return Object.assign({}, state, { getAppraisalQuestionExport: payload });
    case GET_APPRAISAL_QUESTION_OPTION:
      return Object.assign({}, state, { getAppraisalQuestionOption: payload });
    case GET_APPRAISAL_QUESTION_OPTION_EXPORT:
      return Object.assign({}, state, {
        getAppraisalQuestionOptionExport: payload
      });
    case GET_EMPLOYEE_APPRAISAL_QUESTION:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestion: payload
      });
    case GET_EMPLOYEE_APPRAISAL:
      return Object.assign({}, state, { getEmployeeAppraisal: payload });
    case GET_EMPLOYEE_APPRAISAL_EXPORT:
      return Object.assign({}, state, { getEmployeeAppraisalExport: payload });
    case GET_APPRAISAL:
      return Object.assign({}, state, { getAppraisal: payload });
    case GET_APPRAISAL_CATEGORY:
      return Object.assign({}, state, { getAppraisalCategory: payload });
    case GET_APPRAISAL_RATING:
      return Object.assign({}, state, { getAppraisalRating: payload });
    case GET_QUESTION:
      return Object.assign({}, state, { getFeedbackQuestion: payload });
    case GET_QUESTION_VALUE:
      return Object.assign({}, state, {
        getFeedbackQuestionOptionValue: payload
      });
    case GET_QUESTION_VALUE_SET:
      return Object.assign({}, state, {
        getFeedbackQuestionOptionValueSet: payload
      });
    case GET_APPRAISAL_QUESTION_PRINT:
      return Object.assign({}, state, { getAppraisalQuestionPrint: payload });
    case GET_HR_LEAVE_TYPE:
      return Object.assign({}, state, { getHrLeaveType: payload });
    case GET_EMPLOYEE_APPRAISAL_QUESTION_PRINT:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestionPrint: payload
      });
    case GET_TO_DO_CATEGORY:
      return Object.assign({}, state, { getToDoCategory: payload });
    case GET_HR_APPRAISAL_QUESTION_DESIGNATION_FOR_UPDATE:
      return Object.assign({}, state, {
        getHrAppraisalQuestionDesignationForUpdate: payload
      });
    case GET_HR_APPRAISAL_QUESTION_DESIGNATION:
      return Object.assign({}, state, {
        getHrAppraisalQuestionDesignation: payload
      });
    case GET_APPRAISAL_RATING_EXPORT:
      return Object.assign({}, state, { getAppraisalRatingExport: payload });
    case GET_APPRAISAL_QUESTION_CATEGORY_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionCategoryFilter: payload
      });
    case GET_APPRAISAL_QUESTION_DEPARTMENT_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionDepartmentFilter: payload
      });
    case GET_APPRAISAL_QUESTION_DESIGNATION_FILTER:
      return Object.assign({}, state, {
        getAppraisalQuestionDesignationFilter: payload
      });
    case GET_HR_APPRAISAL_QUESTION_OPTION:
      return Object.assign({}, state, {
        getHrAppraisalQuestionOption: payload
      });
    case GET_HR_APPRAISAL_QUESTION_OPTION_DETAIL:
      return Object.assign({}, state, {
        getHrAppraisalQuestionOptionDetail: payload
      });
    case GET_EMPLOYEE_FOR_APPRAISAL:
      return Object.assign({}, state, { getEmployeeForAppraisal: payload });
    case GET_EMPLOYEE_APPRAISAL_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterEmployee: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_APPRAISAL:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterAppraisal: payload
      });
    case GET_EMPLOYEE_DEPARTMENT_FOR_APPRAISAL:
      return Object.assign({}, state, {
        getEmployeeDepartmentForAppraisal: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterDepartment: payload
      });
    case GET_EMPLOYEE_APPRAISAL_FILTER_DESGINATION:
      return Object.assign({}, state, {
        getEmployeeAppraisalFilterDesgination: payload
      });

    case GET_EMPLOYEE_APPRAISAL_DETAIL:
      return Object.assign({}, state, { getEmployeeAppraisalDetail: payload });
    case GET_PENDING_TODO:
      return Object.assign({}, state, { getPendingToDo: payload });
    case GET_USER_ROLE_FUNCTIONALITY_DETAIL:
      return Object.assign({}, state, {
        getUserRoleFunctionalityDetail: payload
      });
    case GET_USER_ROLE_FUNCTIONALITY_FILTER_DESIGNATION:
      return Object.assign({}, state, {
        getUserRoleFunctionalityFilterDesignation: payload
      });
    case GET_USER_ROLE_FUNCTIONALITY_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getUserRoleFunctionalityFilterDepartment: payload
      });
    case GET_USER_BATA:
      return Object.assign({}, state, {
        getUserBata: payload
      });
    case GET_USER_BATA_FILTER_USER:
      return Object.assign({}, state, {
        getUserBataFilterUser: payload
      });
    case GET_USER_BATA_EXPORT:
      return Object.assign({}, state, {
        getUserBataExport: payload
      });

    //full and final
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlement: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementFilterDepartment: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementFilterEmployee: payload
      });
    case GET_EMPLOYEE_FOR_PENDING_SETTLEMENT_EXPORT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementExport: payload
      });
    case GET_EMPLOYEE_FINAL_SETTLEMENT_DETAIL:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementDetail: payload
      });
    case GET_EMPLOYEE_FINAL_SETTLEMENT_PRINT:
      return Object.assign({}, state, {
        getEmployeeFinalSettlementPrint: payload
      });

    //SALARY ADVANCE
    case GET_HR_SALARY_ADVANCE_DETAIL:
      return Object.assign({}, state, {
        getHrSalaryAdvanceDetail: payload
      });
    case GET_HR_SALARY_ADVANCE_FILTER_USER:
      return Object.assign({}, state, {
        getHrSalaryAdvanceFilterUser: payload
      });
    case GET_HR_SALARY_ADVANCE_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getHrSalaryAdvanceFilterDepartment: payload
      });
    case GET_ADMIN_SETTING_VALUE:
      return Object.assign({}, state, {
        getAdmSettingValue: payload
      });
    case GET_SETTING_ITEM:
      return Object.assign({}, state, {
        getSettingItem: payload
      });
    case GET_ADMIN_SETTING:
      return Object.assign({}, state, {
        getAdmSetting: payload
      });
    case GET_SETTING_ITEM_OPTION:
      return Object.assign({}, state, {
        getSettingItemOption: payload
      });
    case GET_ADMIN_SETTING_DETAILS:
      return Object.assign({}, state, {
        getAdmSettingDetail: payload
      });
    case GET_CRM_SITE_STATUS_FOR_RELEASE_STATUS:
      return Object.assign({}, state, {
        getCrmSiteStatusForReleaseStatus: payload
      });
    //SALARY SLIP
    case GET_SALARY_SLIP:
      return Object.assign({}, state, {
        getSalarySlip: payload
      });

    case GET_SALARY_SLIP_EXPORT:
      return Object.assign({}, state, {
        getSalarySlipExport: payload
      });

    case GET_SALARY_SLIP_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getSalarySlipFilterDepartment: payload
      });

    case GET_SALARY_SLIP_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getSalarySlipFilterEmployee: payload
      });
    case GET_SALARY_SLIP_FILTER_EMPLOYEE_TYPE:
      return Object.assign({}, state, {
        getSalarySlipFilterEmployeeType: payload
      });

    case GET_EMPLOYEE_APPRAISAL_QUESTION_DETAIL:
      return Object.assign({}, state, {
        getEmployeeAppraisalQuestionDetail: payload
      });

    case GET_SALARY_SLIP_DETAIL:
      return Object.assign({}, state, {
        getSalarySlipDetail: payload
      });
    case GET_PAYMENT_AUTHORITY:
      return Object.assign({}, state, { getPaymentAuthority: payload });
    case GET_PAYMENT_AUTHORITY_EXPORT:
      return Object.assign({}, state, { getPaymentAuthorityExport: payload });
    case GET_PAYMENT_AUTHORITY_FILTER_PAYMENT_CATEGORY:
      return Object.assign({}, state, {
        getPaymentAuthorityFilterPayment: payload
      });
    case GET_PAYMENT_AUTHORITY_FILTER_USER:
      return Object.assign({}, state, {
        getPaymentAuthorityFilterUser: payload
      });
    case GET_PAYMENT_CATEGORIES:
      return Object.assign({}, state, {
        getPaymentCategories: payload
      });
    //Meeting
    case GET_ADMIN_MEETING:
      return Object.assign({}, state, { getAdminMeeting: payload });
    case GET_ADMIN_MEETING_DETAIL:
      return Object.assign({}, state, { getAdminMeetingDetail: payload });
    case GET_ADMIN_MEETING_CATEGORY:
      return Object.assign({}, state, { getMeetingCategory: payload });
    case GET_ATTENDEE_FOR_ADMIN_MEETING:
      return Object.assign({}, state, { getAttendeeForAdminMeeting: payload });
    case GET_ADMIN_MEETING_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAdminMeetingFilterDepartment: payload
      });
    case GET_ADMIN_MEETING_FILTER_HOSTED_BY:
      return Object.assign({}, state, {
        getAdminMeetingFilterHostedBy: payload
      });
    case GET_ADMIN_MEETING_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getAdminMeetingFilterCategory: payload
      });
    // Training
    case GET_TRAINING_SCHEDULE:
      return Object.assign({}, state, { getTrainingSchedule: payload });
    case GET_TRAINING_SCHEDULE_DETAIL:
      return Object.assign({}, state, { getTrainingScheduleDetail: payload });
    case GET_TRAINING_SCHEDULE_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getTrainingScheduleFilterDepartment: payload
      });
    case GET_TRAINING_SCHEDULE_FILTER_TRAINER:
      return Object.assign({}, state, {
        getTrainingScheduleFilterTrainer: payload
      });
    case GET_ATTENDEE_FOR_TRAINING_SCHEDULE:
      return Object.assign({}, state, {
        getAttendeeForTrainingSchedule: payload
      });
    case GET_ATTENDEE_TRAINING_SCHEDULE:
      return Object.assign({}, state, {
        getAttendeeTrainingSchedule: payload
      });
    case GET_TRAINING_SCHEDULE_EXPORT:
      return Object.assign({}, state, {
        getTrainingScheduleExport: payload
      });
    case GET_TRAINING_ATTENDEE_EXPORT:
      return Object.assign({}, state, {
        getTrainingAttendeeExport: payload
      });
    case GET_TRAINING_FILTER_TRAINER:
      return Object.assign({}, state, {
        getTrainingFilterTrainer: payload
      });
    // Admin Training
    case GET_TRAINING:
      return Object.assign({}, state, {
        getTraining: payload
      });
    case GET_TRAINING_DETAIL:
      return Object.assign({}, state, {
        getTrainingDetail: payload
      });
    case GET_TRAINING_DOCUMENT:
      return Object.assign({}, state, {
        getTrainingDocument: payload
      });
    case GET_TRAINING_ATTENDEE:
      return Object.assign({}, state, {
        getTrainingAttendee: payload
      });
    case GET_TRAINING_FEEDBACK:
      return Object.assign({}, state, {
        getTrainingFeedback: payload
      });
    case GET_TRAINING_AVAILABILITY:
      return Object.assign({}, state, {
        getTrainerAvailability: payload
      });
    // ticket
    case GET_TICKET:
      return Object.assign({}, state, {
        getTicket: payload
      });
    case GET_TICKET_EXPORT:
      return Object.assign({}, state, {
        getTicketExport: payload
      });
    case GET_TICKET_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getTicketFilterDepartment: payload
      });
    case GET_TICKET_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getTicketFilterAssignedTo: payload
      });
    case GET_TICKET_DETAIL:
      return Object.assign({}, state, {
        getTicketDetail: payload
      });
    case GET_TICKET_STATUS:
      return Object.assign({}, state, {
        getTicketStatus: payload
      });
    case GET_TICKET_FILTER_STATUS:
      return Object.assign({}, state, {
        getTicketFilterStatus: payload
      });
    //Module Requirement
    case GET_MODULE_REQUIREMENT:
      return Object.assign({}, state, {
        getModuleRequirement: payload
      });
    case GET_MODULE_REQUIREMENT_DETAIL:
      return Object.assign({}, state, {
        getModuleRequirementDetail: payload
      });
    case GET_MODULE_REQUIREMENT_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getModuleRequirementFilterDepartment: payload
      });
    case GET_MODULE_REQUIREMENT_EXPORT:
      return Object.assign({}, state, {
        getModuleRequirementExport: payload
      });
    case GET_MODULE_REQUIREMENT_FILTER_DEVELOPER_STATUS:
      return Object.assign({}, state, {
        getModuleRequirementFilterDevelopementStatus: payload
      });
    // User Project Map
    case GET_PROJECT_USER_MAP:
      return Object.assign({}, state, {
        getProjectUserMap: payload
      });
    case GET_PROJECT_USER_MAP_FILTER_PROJECT:
      return Object.assign({}, state, {
        getProjectUserMapFilterProject: payload
      });
    case GET_PROJECT_USER_MAP_FILTER_USER:
      return Object.assign({}, state, {
        getProjectUserMapFilterUser: payload
      });
    case GET_ITEM_FOR_PROJECT_USER_MAP:
      return Object.assign({}, state, {
        getItemForProjectUserMap: payload
      });
    case GET_PROJECT_USER_MAP_EXPORT:
      return Object.assign({}, state, {
        getProjectUserMapExport: payload
      });
    default:
      return state;
  }
};
export default Admin_reducer;
